import { getErrorCode } from "./getErrorCode";
import { getErrorMessage } from "./getErrorMessage";
import { ITEM_TO_BAG } from "../../constants";
import { ERROR } from "../../../common/constants";
import { updateStockIndicationIfNecessary } from "./updateStockIndicationIfNecessary";

export const itemToBagFailure =
  ({ id, e }) =>
  dispatch => {
    updateStockIndicationIfNecessary({ dispatch, e, id });
    dispatch({
      type: ERROR,
      payload: {
        id,
        failedActionType: ITEM_TO_BAG,
        errorCode: getErrorCode(e),
        errorMessage: getErrorMessage(e),
        canBeRetried: false
      }
    });
  };
